// extracted by mini-css-extract-plugin
export var statItem = "_gm-1";
export var statsRow = "_gm-0";